export const Services = () => {
  return (
    <div id="services" className="services">
      <div className="title">Service Menu</div>
      <div className="service-container">
        <div className="service-category">
          <div className="title">Hair</div>
          <div className="multi-col-services">
            <ul>
              <li>Cut $60</li>
              <li>Kids cuts $40</li>
              <li>Single color application starting at $90</li>
              <li>Full highlight/lowlight/balayage $140 - $300</li>
            </ul>
            <ul>
              <li>Extensions removal starting at $150</li>
              <li>Extension from $250</li>
              <li>Extension fill in $30 per strand</li>
              <li>Intensive hydrating treatment $25</li>
            </ul>
            <ul>
              <li>Split end treatment $30</li>
              <li>Detoxifying treatment $40</li>
              <li>Shampoo and blow dry $45</li>
              <li>Up-do work starting at $90</li>
            </ul>
          </div>
        </div>
        <div className="service-category">
          <div className="title">Makeup</div>
          <br />
          <div className="multi-col-services">
            <ul>
              <div className="subtitle">Weddings</div>
              <li>
                Bridal makeup (includes airbrush or traditional makeup & lashes)
                $145
              </li>
              <li>Bridesmaids airbrush or traditional makeup $95</li>
              <li>Flower girls (12 & under) $30</li>
              <li>False lash application $20 (bridesmaids)</li>
            </ul>

            <ul id="other">
              <div className="subtitle">Other</div>
              <li>In studio $75</li>
              <li>On location $100</li>
            </ul>
          </div>
          <br />
          <div className="note">
            * $200 security deposit reserves your wedding date and will be
            deducted from the balance on the day of your wedding
          </div>
          <div className="note">* $50 travel fee</div>
        </div>
        <div className="service-category">
          <div className="title">Peels</div>
          <ul>
            <li>Custom chemical peel $50 - $200</li>
            <li>Dermaplaning $50</li>
            <li>Dermaplaning & peel $100</li>
          </ul>
        </div>
        <div className="service-category">
          <div className="title">Lashes</div>
          <ul>
            <li>Lash lifts $50</li>
            <li>Tint lashes $30</li>
            <li>Tint brows $20</li>
            <li>False lashes starting at $35</li>
          </ul>
        </div>
        <div className="service-category">
          <div className="title">Waxing</div>
          <div className="multi-col-services">
            <ul>
              <li>Brows $20</li>
              <li>Lip/chin $10</li>
              <li>Face $25</li>
              <li>Neck $15</li>
            </ul>
            <ul>
              <li>Underarm $30</li>
              <li>Arms $35</li>
              <li>Legs $40 - $60</li>
              <li>Chest/back $65</li>
            </ul>
            <ul>
              <li>Bikini $35</li>
              <li>French $40</li>
              <li>Brazilian $50</li>
            </ul>
          </div>
        </div>
        <div className="service-category facials">
          <div className="title">Facials</div>
          <ul>
            <li>Hour facial (peel included) $120</li>
            <li>Hot stone facials (peel included) $130</li>
            <li>
              45-minute dry brushing/exfoliating/hot stone body treatment $80
            </li>
            <li>Microdermabrasion $25</li>
          </ul>
        </div>
        <div className="note">
          * $5 service fee for credit / $3 service fee for Venmo
        </div>
      </div>
    </div>
  );
};
